module.exports = {"version":"0.20.7"}


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/web3/lib/version.json
// module id = b34o
// module chunks = 15